// extracted by mini-css-extract-plugin
export default {"wrapper":"SettlementRulesBlog_wrapper__AFHsc","col":"SettlementRulesBlog_col__Fmhpl"};